export enum EventLogTabs {
  TIMELINE = 'timeline',
  EVENT_LIST = 'event-list',
}
